// Match only the enquiry form we're replacing, including its optional trailing slash.
// Drop the old form's campaign parameters and fragments from the destination.
const enquiryFormUrl = /^https?:\/\/4xnxjq3ufd4\.typeform\.com\/to\/l8TpXYrh\/?(?=[?#]|$)/i;

const replaceTypeformEnquiryUrl = url =>
  typeof url === 'string' && enquiryFormUrl.test(url) ? '/enquiry' : url;

module.exports = { replaceTypeformEnquiryUrl };
